import {
  CraftnoteEvent,
  createCraftnoteEventBuilder,
  GlobalCraftnoteEventParameters
} from "./CraftnoteEvent.generated";
/**
* Container for all events for Notifications
*
*
* this file was auto-generated Craftnote Events Code Generator, for more info visit: https://github.com/craftnote/craftnote-events
*/
export type NotificationsParameters = NotificationsCenterOpenedParameters | NotificationsCenterItemOpenedParameters | NotificationsCenterPaywallOpenedParameters | NotificationsCenterPaywallSelectedParameters | NotificationsSettingsPaywallOpenedParameters | NotificationsSettingsPaywallSelectedParameters;
export type NotificationsEvents = NotificationsCenterOpenedEvent | NotificationsCenterItemOpenedEvent | NotificationsCenterPaywallOpenedEvent | NotificationsCenterPaywallSelectedEvent | NotificationsSettingsPaywallOpenedEvent | NotificationsSettingsPaywallSelectedEvent;

export interface NotificationsCenterOpenedParameters {
	version: string; // version of the mobile or web app
	companyId?: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	role: string; // role of the logged in user, must be any of "owner", "supervisor", "employee"
}

export type NotificationsCenterOpenedParametersSpecific = Omit<
	NotificationsCenterOpenedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const notificationsCenterOpenedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','userId'];

export class NotificationsCenterOpenedEventBuilder {
	constructor(private specificParameters: NotificationsCenterOpenedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<NotificationsCenterOpenedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			NotificationsCenterOpenedParametersSpecific,
            NotificationsCenterOpenedParameters,
			(params: NotificationsCenterOpenedParameters) => NotificationsCenterOpenedEvent
		>(this.specificParameters, notificationsCenterOpenedParametersGlobal, globalParams, (params) => new NotificationsCenterOpenedEvent(params));
	}
}

/**
 * A user opened the notification center.
 */
export class NotificationsCenterOpenedEvent extends CraftnoteEvent<NotificationsCenterOpenedParameters>{
  constructor(parameters: NotificationsCenterOpenedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "notifications_center_opened"
		},
		{
			name: "iterable",
			eventName: "notifications_center_opened"
		},
	]);
  }
}
export interface NotificationsCenterItemOpenedParameters {
	version: string; // version of the mobile or web app
	companyId?: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	notificationType: string; // the type of the notification delivered via cloud function with the type parameter
}

export type NotificationsCenterItemOpenedParametersSpecific = Omit<
	NotificationsCenterItemOpenedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const notificationsCenterItemOpenedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','userId'];

export class NotificationsCenterItemOpenedEventBuilder {
	constructor(private specificParameters: NotificationsCenterItemOpenedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<NotificationsCenterItemOpenedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			NotificationsCenterItemOpenedParametersSpecific,
            NotificationsCenterItemOpenedParameters,
			(params: NotificationsCenterItemOpenedParameters) => NotificationsCenterItemOpenedEvent
		>(this.specificParameters, notificationsCenterItemOpenedParametersGlobal, globalParams, (params) => new NotificationsCenterItemOpenedEvent(params));
	}
}

/**
 * A user clicked on a clickable notification item on the notification center.
 */
export class NotificationsCenterItemOpenedEvent extends CraftnoteEvent<NotificationsCenterItemOpenedParameters>{
  constructor(parameters: NotificationsCenterItemOpenedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "notifications_center_item_opened"
		},
		{
			name: "iterable",
			eventName: "notifications_center_item_opened"
		},
	]);
  }
}
export interface NotificationsCenterPaywallOpenedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type NotificationsCenterPaywallOpenedParametersSpecific = Omit<
	NotificationsCenterPaywallOpenedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const notificationsCenterPaywallOpenedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class NotificationsCenterPaywallOpenedEventBuilder {
	constructor(private specificParameters: NotificationsCenterPaywallOpenedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<NotificationsCenterPaywallOpenedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			NotificationsCenterPaywallOpenedParametersSpecific,
            NotificationsCenterPaywallOpenedParameters,
			(params: NotificationsCenterPaywallOpenedParameters) => NotificationsCenterPaywallOpenedEvent
		>(this.specificParameters, notificationsCenterPaywallOpenedParametersGlobal, globalParams, (params) => new NotificationsCenterPaywallOpenedEvent(params));
	}
}

/**
 * A paywall was shown to a basic user in the notification center.
 */
export class NotificationsCenterPaywallOpenedEvent extends CraftnoteEvent<NotificationsCenterPaywallOpenedParameters>{
  constructor(parameters: NotificationsCenterPaywallOpenedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "notifications_center_paywall_opened"
		},
		{
			name: "iterable",
			eventName: "notifications_center_paywall_opened"
		},
	]);
  }
}
export interface NotificationsCenterPaywallSelectedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type NotificationsCenterPaywallSelectedParametersSpecific = Omit<
	NotificationsCenterPaywallSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const notificationsCenterPaywallSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class NotificationsCenterPaywallSelectedEventBuilder {
	constructor(private specificParameters: NotificationsCenterPaywallSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<NotificationsCenterPaywallSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			NotificationsCenterPaywallSelectedParametersSpecific,
            NotificationsCenterPaywallSelectedParameters,
			(params: NotificationsCenterPaywallSelectedParameters) => NotificationsCenterPaywallSelectedEvent
		>(this.specificParameters, notificationsCenterPaywallSelectedParametersGlobal, globalParams, (params) => new NotificationsCenterPaywallSelectedEvent(params));
	}
}

/**
 * A user clicked on the CTA of the notification center restriction paywall.
 */
export class NotificationsCenterPaywallSelectedEvent extends CraftnoteEvent<NotificationsCenterPaywallSelectedParameters>{
  constructor(parameters: NotificationsCenterPaywallSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "notifications_center_paywall_selected"
		},
		{
			name: "iterable",
			eventName: "notifications_center_paywall_selected"
		},
	]);
  }
}
export interface NotificationsSettingsPaywallOpenedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type NotificationsSettingsPaywallOpenedParametersSpecific = Omit<
	NotificationsSettingsPaywallOpenedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const notificationsSettingsPaywallOpenedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class NotificationsSettingsPaywallOpenedEventBuilder {
	constructor(private specificParameters: NotificationsSettingsPaywallOpenedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<NotificationsSettingsPaywallOpenedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			NotificationsSettingsPaywallOpenedParametersSpecific,
            NotificationsSettingsPaywallOpenedParameters,
			(params: NotificationsSettingsPaywallOpenedParameters) => NotificationsSettingsPaywallOpenedEvent
		>(this.specificParameters, notificationsSettingsPaywallOpenedParametersGlobal, globalParams, (params) => new NotificationsSettingsPaywallOpenedEvent(params));
	}
}

/**
 * A paywall was shown to a basic user in the notification settings.
 */
export class NotificationsSettingsPaywallOpenedEvent extends CraftnoteEvent<NotificationsSettingsPaywallOpenedParameters>{
  constructor(parameters: NotificationsSettingsPaywallOpenedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "notifications_settings_paywall_opened"
		},
		{
			name: "iterable",
			eventName: "notifications_settings_paywall_opened"
		},
	]);
  }
}
export interface NotificationsSettingsPaywallSelectedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type NotificationsSettingsPaywallSelectedParametersSpecific = Omit<
	NotificationsSettingsPaywallSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const notificationsSettingsPaywallSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class NotificationsSettingsPaywallSelectedEventBuilder {
	constructor(private specificParameters: NotificationsSettingsPaywallSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<NotificationsSettingsPaywallSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			NotificationsSettingsPaywallSelectedParametersSpecific,
            NotificationsSettingsPaywallSelectedParameters,
			(params: NotificationsSettingsPaywallSelectedParameters) => NotificationsSettingsPaywallSelectedEvent
		>(this.specificParameters, notificationsSettingsPaywallSelectedParametersGlobal, globalParams, (params) => new NotificationsSettingsPaywallSelectedEvent(params));
	}
}

/**
 * A user clicked on the CTA of the notification settings restriction paywall.
 */
export class NotificationsSettingsPaywallSelectedEvent extends CraftnoteEvent<NotificationsSettingsPaywallSelectedParameters>{
  constructor(parameters: NotificationsSettingsPaywallSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "notifications_settings_paywall_selected"
		},
		{
			name: "iterable",
			eventName: "notifications_settings_paywall_selected"
		},
	]);
  }
}
